import React from "react"

import classNames from "classnames"

import { Hint } from "shared/ui/hint/Hint"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_api-status.scss"

interface APIStatusProps {
  unavailableMessage: string
  isUnavailable: boolean
  className?: string
}

export const APIStatus = React.memo(
  ({ isUnavailable, unavailableMessage, className }: APIStatusProps) => {
    if (isUnavailable) {
      return (
        <Hint.Root
          variant="danger"
          className={classNames("api-status", "hint--banner", className)}
          data-testid="api-status"
        >
          <Hint.Icon name={IconName.CLOSE_CIRCLE} />
          <Hint.Content>
            <Hint.Text>{unavailableMessage}</Hint.Text>
          </Hint.Content>
        </Hint.Root>
      )
    }
    return null
  }
)
